export default {
  title: 'Traccia il tuo ordine',
  text: 'Grazie per aver ordinato qui! La nostra partnership con <0>{{carrier}}</0> ci permette di gestire le consegne direttamente sul nostro sito, risparmiando in media {{savings}} in commissioni di consegna. Il tuo ordine sarà consegnato da <1>{{carrier}}</1>, garantendo un ottimo servizio 😊',
  labels: {
    delivered_by: 'Consegnato da',
  },
  buttons: {
    track_order: 'Ricevi aggiornamenti in tempo reale →',
    track_order_once_confirmed: 'Ricevi aggiornamenti in tempo reale alla conferma',
  },
};
